import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "../components/AuthProvider.tsx";
import Moment from "moment";
import Search from "../models/Search.tsx";
import MenuComponent from "../components/Menu.tsx";

function Applications() {
  const navigate = useNavigate();
  const { authorization, SetAuthorization } = useAuth();
  const [applications, SetApplications] = useState<Search[]>([]);

  useEffect(() => {
    if (authorization) {
      fetch("/api/applications?token=" + authorization.Token)
        .then(response => response.json())
        .then(data => SetApplications(data))
        .catch(error => console.log(error));
    }
  }, [authorization]);

  return (
    <>
      <MenuComponent page={"Applications"} />

      <section id="main">
        <div className="container">
          <div className="appList">
            <article>
              <div></div>
              <div>Application # </div>
              <div>Applicant Name</div>
              <div>Job Title </div>
              <div>Last Modified Date</div>
            </article>

            {applications.map(application => (
              <article key={application.ApplicationId}>
                <div>
                  <ul>
                    <li><a onClick={() => navigate("/application/" + application.ApplicationId)}><img src="/images/icon-edit.png" alt="Edit Application" title="Edit Application" /></a></li>
                    <li>
                      <span className="tooltip">
                        {application.ApplicationStatusId === 1 && <><img src="/images/Application-Submitted.png" alt="Submitted" /><span className="tooltiptext">Application Submitted</span></>}
                        {application.ApplicationStatusId === 2 && <><img src="/images/Application-Reviewed.png" alt="Reviewed" /><span className="tooltiptext">Application Reviewed</span></>}
                        {application.ApplicationStatusId === 3 && <><img src="/images/Application-Incomplete.png" alt="Incomplete" /><span className="tooltiptext">Application Incomplete</span></>}
                        {application.ApplicationStatusId === 4 && <><img src="/images/Application-Accepted.png" alt="Accepted" /><span className="tooltiptext">Application Accepted</span></>}
                        {application.ApplicationStatusId === 5 && <><img src="/images/Application-Declined.png" alt="Declined" /><span className="tooltiptext">Application Declined</span></>}
                        {application.ApplicationStatusId === 6 && <><img src="/images/Application-Withdrawn.png" alt="Withdrawn" /><span className="tooltiptext">Employer Withdrawn</span></>}
                      </span>
                    </li>
                  </ul>
                </div>
                <div>{application.JobNumber}</div>
                <div>{application.Contact}</div>
                <div>{application.JobTitle}</div>
                <div>{Moment(application.ModifiedOn).format("MMM DD, yyyy")}</div>
              </article>
            ))}
          </div>

          <p className="formButton biggerSpace"><a className="button" onClick={() => navigate("/application")}>Create Application</a></p>
        </div>
      </section>
    </>
  );
}

export default Applications;